module.exports = __webpack_public_path__ + "img/天气实况背景.30946280.png";